(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ul-product-gallery]').forEach((shell) => {
      if (shell.dataset.ulGalleryReady === 'true') return;
      shell.dataset.ulGalleryReady = 'true';

      const track = shell.querySelector('[data-ul-product-gallery-track]');
      const next = shell.querySelector('[data-ul-product-gallery-next]');
      if (!track || !next) return;
      let autoplay;

      const slides = () => [...track.querySelectorAll(':scope > .ul-product__media')];
      const step = () => {
        const items = slides();
        return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      };
      const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      const update = () => {
        const hasOverflow = mobile.matches && slides().length > 1 && track.scrollWidth > track.clientWidth + 2;
        next.hidden = !hasOverflow || atEnd();
      };
      const advance = () => {
        if (!mobile.matches) return;
        track.scrollTo({ left: atEnd() ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
      };
      const stopAutoplay = () => window.clearTimeout(autoplay);
      const scheduleAutoplay = () => {
        stopAutoplay();
        if (!mobile.matches || reducedMotion.matches || slides().length < 2) return;
        autoplay = window.setTimeout(() => {
          advance();
          scheduleAutoplay();
        }, 3000);
      };

      next.addEventListener('click', () => {
        advance();
        scheduleAutoplay();
      });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('touchstart', stopAutoplay, { passive: true });
      track.addEventListener('touchend', scheduleAutoplay, { passive: true });
      shell.addEventListener('focusin', stopAutoplay);
      shell.addEventListener('focusout', scheduleAutoplay);
      mobile.addEventListener('change', () => {
        update();
        scheduleAutoplay();
      });
      new ResizeObserver(update).observe(track);
      requestAnimationFrame(() => {
        update();
        scheduleAutoplay();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
